import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  acceptAllTerms,
  areTOSAcceptedByUser,
  getAcceptedTerms,
} from '../../../../modules/Terms';
import { IRootDispatch, RootState } from '../../../../store/models';
import { selectors as CurrentUserSelectors } from '../../../../store/CurrentUser.model';
import { useAsyncEffect } from '../../../../hooks';

import { LegalDoc, LegalModal } from '../LegalModal';

const ForceTOSAcceptContainer = () => {
  const dispatch = useDispatch<IRootDispatch>();
  const userId = useSelector<RootState, number>(CurrentUserSelectors.getId);
  const isNewUser = useSelector<RootState, boolean>(state => state.user.is_new_user);
  const providerId = useSelector<RootState, number>(CurrentUserSelectors.getProviderId);

  const [show, setShow] = useState(false);
  const isProvider = !!providerId;

  useAsyncEffect(async () => {
    // new users automatically accept the terms and conditions during sign up.
    // unfortunately the backend doesn't immediately reflect that so
    // we just don't show this for new users during this session
    if (!userId || isNewUser) return;

    const terms = await getAcceptedTerms();
    const accepted = areTOSAcceptedByUser(terms, isProvider);
    if (!accepted) setShow(true);
  }, [
    userId,
    providerId,
  ]);

  const handleConfirm = () => {
    acceptAllTerms(userId, providerId);
    setShow(false);
  };

  const handleLogout = () => {
    dispatch.user.logout();
    dispatch.route.go({
      route: 'home', replace: true, notify: true,
    });
    setShow(false);
  };

  return !show ? null : (
    <LegalModal
      doc={isProvider ? LegalDoc.ProTermsOfService : LegalDoc.ConsumerTermsOfService}
      onConfirm={handleConfirm}
      onDismiss={handleLogout}
      dismissText="Log out"
      mandatory
    />
  );
};

export default ForceTOSAcceptContainer;
